/**
 * Links that open the Breakdown editor on one scene: `script/breakdown?scene=<scene_id>`.
 * The editor reads the parameter on entry and whenever it changes, opens that scene when the
 * open draft has it (else its first scene, as without a link), then drops the parameter.
 */
export const SCENE_LINK_PARAM = "scene";

/** The Breakdown editor path, opened on `sceneId` when one is given. */
export function scriptBreakdownPath(
  workspaceId: string,
  projectId: string,
  sceneId?: number | null
): string {
  const path = `/workspaces/${workspaceId}/projects/${projectId}/script/breakdown`;
  return sceneId != null ? `${path}?${SCENE_LINK_PARAM}=${sceneId}` : path;
}

/** The scene id a link names, or undefined for a missing or malformed value. */
export function parseSceneLinkParam(value: string | null): number | undefined {
  if (!value || !/^\d+$/.test(value)) return undefined;
  const sceneId = Number(value);
  return sceneId > 0 ? sceneId : undefined;
}
